export default "__VITE_ASSET__jSByhX_p__"